<script setup lang="ts">
import { mdiCogOutline } from "@mdi/js";
import { useScreenSize } from "@soft-db/ui";
import NavButton from "./NavButton.vue";

defineProps<{
	id: string;
	disabled?: boolean;
	disabledReason?: string;
}>();

const { t } = useI18n();
const { mdOrLower } = useScreenSize();
</script>

<template>
	<NavButton
		:title="t('common.settings')"
		:icon="mdiCogOutline"
		:to="{
			name: 'reports-id-settings',
			params: { id },
		}"
		color="default"
		:disabled="disabled"
		:disabledReason="disabledReason"
		:size="mdOrLower ? 'lg' : 'sm'"
	/>
</template>
